import React from 'react'

import { FileListPreview } from '@/components/FileListPreview'

export function MsgTemplatePreview({ state, dispatch }) {
  const { msgTemplate, attachments } = state

  return (
    <>
      <div
        className='prose prose-sm border rounded-lg shadow bg-gray-50 p-5'
        dangerouslySetInnerHTML={{ __html: msgTemplate }}
      />

      <div>
        <p className='text-base font-semibold text-sky-700 mt-10 mb-3'>File Attachments</p>

        {attachments?.length > 0 ? (
          <FileListPreview
            files={attachments}
            clearFiles={(fileToRemove) => {
              dispatch({ type: 'removeAttachment', payload: fileToRemove.name })
            }}
          />
        ) : (
          <p className='text-sm text-gray-500 mt-3 text-center'>
            No files will be attached to this message
          </p>
        )}
      </div>
    </>
  )
}
